/* A small, consent-gated funnel. No form values, project IDs, or resume URLs. */
(function (global, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else api.mount(global);
}(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  var steps = ['what', 'many', 'who', 'to', 'back', 'done'];
  function create(options) {
    var seen = {};
    return function track(event, data) {
      if (options.preview || !options.allowed()) return false;
      var payload = { funnel_version: 'fmt-v4-six-step' };
      if (event === 'fmt_builder_step_view') {
        var index = steps.indexOf(data && data.step);
        if (index < 0) return false;
        payload.step_name = steps[index]; payload.step_number = index + 1;
      } else if (event === 'fmt_estimate_click') {
        payload.link_location = ['header', 'hero', 'content', 'footer'].indexOf(data && data.location) >= 0 ? data.location : 'content';
      } else if (event !== 'fmt_checkout_click') return false;
      var key = event + ':' + (payload.step_name || payload.link_location || '');
      if (seen[key]) return false;
      try {
        if (options.send(event, payload) === false) return false;
        seen[key] = true;
        return true;
      } catch (error) { return false; }
    };
  }
  function mount(win) {
    var doc = win.document;
    var config = doc.querySelector('script[data-fmt-measurement]');
    if (!config || config.getAttribute('data-fmt-measurement') !== 'live') return;
    // Owner/test browsers can opt out of FMT custom events across page visits.
    // This does not change Shopify's purchase pixel or Google's pageview tags.
    try {
      var mode = new URLSearchParams(win.location.search || '').get('fmt_test');
      if (mode === '1') win.localStorage.setItem('fmt_measurement_test', '1');
      if (mode === '0') win.localStorage.removeItem('fmt_measurement_test');
      if (win.localStorage.getItem('fmt_measurement_test') === '1') return;
    } catch (_) {}
    if (/[?&]preview_theme_id=/.test(win.location.search || '') || (win.Shopify && win.Shopify.designMode)) return;
    function allowed() {
      try { return !!(win.Shopify && win.Shopify.customerPrivacy && win.Shopify.customerPrivacy.analyticsProcessingAllowed()); }
      catch (_) { return false; }
    }
    function send(event, payload) {
      if (typeof win.gtag !== 'function') return false;
      payload.page_location = win.location.origin + win.location.pathname;
      payload.page_referrer = '';
      win.gtag('event', event, payload);
      return true;
    }
    var leads = createLeads({ allowed: allowed, send: send, storage: function () { return win.sessionStorage; }, now: Date.now });
    function confirmation() {
      if (doc.querySelector('[data-fmt-enquiry-accepted]')) leads.confirm();
    }
    var track = create({
      preview: false,
      allowed: allowed,
      send: function (event, payload) {
        if (typeof win.gtag !== 'function') return false;
        // GA4 otherwise adds the full document URL/referrer automatically.
        // Keep portable project payloads out of these custom funnel events.
        payload.page_location = win.location.origin + win.location.pathname;
        payload.page_referrer = '';
        win.gtag('event', event, payload);
      }
    });
    var currentStep = null;
    win.addEventListener('fmt:builder-step', function (event) {
      currentStep = event.detail && event.detail.step;
      track('fmt_builder_step_view', { step: currentStep });
    });
    doc.addEventListener('visitorConsentCollected', function () {
      if (currentStep) track('fmt_builder_step_view', { step: currentStep });
      confirmation();
    });
    doc.addEventListener('submit', function (event) {
      var form = event.target;
      if (form && (form.id === 'fmt-enquiry-form' || (form.closest && form.closest('.fmt-contact')))) leads.begin(form.id === 'fmt-enquiry-form' ? 'enquiry_modal' : 'contact_page');
    }, true);
    doc.addEventListener('click', function (event) {
      var target = event.target && event.target.closest ? event.target : null;
      if (!target) return;
      var checkout = target.closest('[data-checkout]');
      if (checkout && !checkout.disabled) track('fmt_checkout_click', {});
      var link = target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      if (/^tel:/i.test(href)) {
        var place = link.closest('header') ? 'header' : link.closest('.fmt-help') ? 'order_builder_help' : link.closest('footer') ? 'footer' : link.closest('.fmt-contact') ? 'contact_page' : link.closest('.fmt-locations') ? 'locations' : link.closest('.fmt-hero, .fmt-page-hero, .archive-hero') ? 'hero' : 'content';
        leads.phone(href, place);
        return;
      }
      if (!/^\/pages\/(start-order|build-order|order-builder)(?:[#?]|$)/.test(href)) return;
      var location = link.closest('header') ? 'header' : link.closest('.archive-hero') ? 'hero' : link.closest('footer') ? 'footer' : 'content';
      track('fmt_estimate_click', { location: location });
    }, true);
    confirmation();
    if (win.Shopify && typeof win.Shopify.loadFeatures === 'function') {
      win.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (!error) { if (currentStep) track('fmt_builder_step_view', { step: currentStep }); confirmation(); }
      });
    }
  }
  function createLeads(options) {
    var memory = {}, timeout = 30 * 60 * 1000;
    function emit(name, payload) { try { return options.send(name, payload) !== false; } catch (_) { return false; } }
    function read(key) { try { var raw = options.storage().getItem('fmt_lead_' + key); return raw ? JSON.parse(raw) : memory[key]; } catch (_) { return memory[key]; } }
    function write(key, value) { memory[key] = value; try { options.storage().setItem('fmt_lead_' + key, JSON.stringify(value)); } catch (_) {} }
    return {
      phone: function (href, location) {
        if (!options.allowed()) return false;
        var digits = href.replace(/\D/g, '').replace(/^1(?=\d{10}$)/, '');
        if (digits !== '6126494707') return false;
        var now = options.now(), last = read('phone');
        if (last && now - last.at < timeout && now >= last.at) return false;
        if (['header','hero','order_builder_help','footer','contact_page','locations','content'].indexOf(location) < 0) location = 'content';
        if (!emit('phone_call_click', { link_location: location, measurement_version: 'fmt-leads-v2', lead_stage: 'phone_intent' })) return false;
        write('phone', { at: now }); return true;
      },
      begin: function (source) {
        if (!options.allowed()) return false;
        if (['enquiry_modal','contact_page'].indexOf(source) < 0) return false;
        write('pending', { at: options.now(), source: source, sent: false }); return true;
      },
      confirm: function () {
        if (!options.allowed()) return false;
        var p = read('pending'), now = options.now();
        if (!p || p.sent || now < p.at || now - p.at > timeout) return false;
        if (['enquiry_modal','contact_page'].indexOf(p.source) < 0) return false;
        if (!emit('enquiry_submit', { form_id: p.source, measurement_version: 'fmt-leads-v2', lead_stage: 'shopify_accepted' })) return false;
        p.sent = true; write('pending', p); return true;
      }
    };
  }
  return { create: create, mount: mount, createLeads: createLeads };
}));
